import { createSelector } from 'reselect';

import type { IApplicationState } from '../../types/redux';
import { getRegion } from '../filters/getRegion';

/**
 * Фильтры текущего таба вместе с регионом — для ссылок пагинации. Совпадают с параметрами,
 * которые экшены пагинации кладут в URL через pushState
 */
export const getPaginationFilters = createSelector(
  (state: IApplicationState) => state[state.tab].filters,
  getRegion,
  (filters, region) => ({ ...filters, regionId: region.id }),
);
